export const HEADER_4_CONSTANTS = {
  HEADER_FIELDS_CONFIG: [
    {
      fieldName: "promotional_text",
      label: "Announcement",
      value:
        "Admissions closing soon — {Apply now} for early benefits",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 2,
      placeholder: "Plain text. Put the link label inside curly braces, e.g. {Apply now}",
      required: false,
      defaultValue:
        "Admissions closing soon — {Apply now} for early benefits",
      description:
        "Plain text only. Wrap the part that should be linked in curly braces, e.g. {Apply now}. Only the first {...} pair is used. Set the URL in Link URL; use Link color for the braced text and icon.",
    },
    {
      fieldName: "promotional_text_color",
      label: "Text color (main line)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Color for text outside the {…} segment",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "link_color",
      label: "Link color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Color for text inside {…}, underline, and default arrow",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient start",
      value: "#342B7C",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Gradient start color",
      required: false,
      defaultValue: "#342B7C",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient end",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Gradient end color",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "background_gradient_angle",
      label: "Gradient angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. 90deg, 135deg",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "link_href",
      label: "Link URL",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://… or /path — applies to the text inside { } in the announcement",
      required: false,
      defaultValue: "",
      description:
        "Destination for the first {...} segment in the announcement. Leave empty to show the braced text without a link.",
    },
    {
      fieldName: "link_trailing_image",
      label: "Link icon (optional)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Custom icon after the link; if empty, the default Atlas icon is used",
    },
    {
      fieldName: "link_trailing_image_alt",
      label: "Link icon alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Alt for the optional icon image",
    },
    {
      fieldName: "header_status",
      label: "Header status",
      value: true,
      valueType: "boolean",
      filedType: "SWITCH",
      placeholder: "Show or hide this strip",
      required: false,
      defaultValue: true,
    },
  ],
};
